import {
  getBalancesMonaparty,
  getAssetInfo,
  getAssetInfoByItems,
  getMonacard,
} from './blockchain';
import {
  syncHttpRequest2,
  devLog,
} from './utils';

// RELOAD 
async function reload(state, dispatch, getType, searchItemType, setItemKey) {
  dispatch({ type: 'setState', key: 'accessing', value: true });

  await Promise.all([
    // アイテム情報取得
    getItemNew(state, dispatch, searchItemType, setItemKey)
    .then( items => {
      devLog('items', JSON.stringify(items));

      if (items.body.item.length > 0) {
        // -- アセット情報取得
        getAssetInfo({ dispatch, assets: items.body.item.map( item => item.asset ), assetInfos: state.assetInfo, clientParameters: state.config.clientParameters });

        // -- モナカード情報取得
        const assetCommons = items.body.item.map( item => item.asset_longname === null ? item.asset : item.asset_longname );
        getMonacard({ dispatch, assets: assetCommons, monacards: state.monacard });
      }
    }),

    // ユーザ情報取得
    getUser({ dispatch, getType, addressMain: state.getUser.addressMain }),
    // devLog('usersGeneral', JSON.stringify(usersGeneral));
  ])

  dispatch({ type: 'setState', key: 'accessing', value: false });
}

// RELOAD GALLERY
async function reloadGallery(state, dispatch) {
  if (state.gallery.addressMain !== undefined && state.gallery.addressMain !== null && state.gallery.addressMain !== '') {
    dispatch({ type: 'setState', key: 'accessing', value: true });

    // アイテム情報取得
    await getItem(state, dispatch, [state.gallery.addressMain])
    .then( items => {
      devLog('items', JSON.stringify(items));

      // アセット情報取得
      getAssetInfoByItems(state, dispatch, items);

      // モナカード情報取得
      const assetCommons = Object.keys(items.body).reduce( (acc, cur) => {
        devLog('cur', cur);
        devLog('item', JSON.stringify(items.body[cur].item));
        const assetCommons = items.body[cur].item.map( item => item.asset_longname === null ? item.asset : item.asset_longname );
        return acc.concat(assetCommons);
      }, []);

      getMonacard({ dispatch, assets: assetCommons, monacards: state.monacard });
    })

    dispatch({ type: 'setState', key: 'accessing', value: false });
  }
}

// GET USER
async function getUser({ dispatch, getType, addressMain }) {
  let request = {};
  let messages = {};

  // addressMain: state.getUser.addressMain,

  request.body = JSON.stringify({
    "body": {
      "getType": getType,
      "addressesMain": getType === 'all' ? null : [addressMain],
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_user';
  request.method = 'POST';

  messages = {
  };

  const response = await syncHttpRequest2(request, 'usersGeneral', undefined, undefined, messages, dispatch);

  if ( response.status === 'fulfilled' ) {
    return {
      status: 'fulfilled',
      body: response.body,
    };
  }
  else {
    return {
      status: 'rejected',
    };
  }
}

// GET ITEM
async function getItem(state, dispatch, addresses) {
  let request = {};
  let messages = {};

  /*
  // state固定
  const stateFixed = {
    addressMain: state.getItem.addressMain,
  };
  */

  request.body = JSON.stringify({
    "body": {
      "addressesMain": addresses,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_item';
  request.method = 'POST';

  messages = {
  };

  const response = await syncHttpRequest2(request, 'items', undefined, undefined, messages, dispatch);

  if ( response.status === 'fulfilled' ) {
    return {
      status: 'fulfilled',
      body: response.body,
    };
  }
  else {
    return {
      status: 'rejected',
    };
  }
}

// GET ITEM NEW
async function getItemNew(state, dispatch, searchType, key) {
  let request = {};
  let messages = {};

  /*
  // state固定
  const stateFixed = {
    addressMain: state.getItem.addressMain,
  };
  */

  request.body = JSON.stringify({
    body: {
      searchType: searchType,
      // searchType: 'new',
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MONACOTTO_API_DOMAIN + '/get_item';
  request.method = 'POST';

  messages = {
  };

  const response = await syncHttpRequest2(request, key, undefined, undefined, messages, dispatch);
  // const response = await syncHttpRequest2(request, 'itemsNew', undefined, undefined, messages, dispatch);

  if ( response.status === 'fulfilled' ) {
    return {
      status: 'fulfilled',
      body: response.body,
    };
  }
  else {
    return {
      status: 'rejected',
    };
  }
}

// SET ADDRESSES IN COOKIE
async function setAddressesInCookie({ dispatch, cookies, setCookie, addressMain, cookiesNew, clientParameters }) {
  let response;
  const responseGetBalances = await getBalancesMonaparty({ dispatch, address: addressMain, clientParameters });
  devLog('get balances; result', JSON.stringify(responseGetBalances));

  if (responseGetBalances.status !== 'rejected' &&
      (responseGetBalances.body[clientParameters.cookie.addresses.restrainingToken] === undefined ||
       responseGetBalances.body[clientParameters.cookie.addresses.restrainingToken].quantity === 0)) {
    try {
      let addressHistory = cookies.addresses;

      if (addressHistory === undefined) {
        addressHistory = [];
      }

      addressHistory = addressHistory.filter( item => !cookiesNew.map( cookie => cookie.address ).includes(item.address) );
      addressHistory.unshift(...cookiesNew);
      addressHistory = addressHistory.slice(0, clientParameters.cookie.addresses.maxSize);

      setCookie('addresses', addressHistory, { maxAge: clientParameters.cookie.addresses.maxAge, secure: true, sameSite: 'strict' });

      response = { status: 'fulfilled', body: addressHistory };
    }
    catch (err) {
      devLog('failed to set a cookie.', JSON.stringify(err));
      response = { status: 'rejected', body: err };
    }
  }
  else {
    response = { status: 'rejected', body: 'restrainingToken' };
  }

  return response;
}

// HANDLE CLICK POPUP USER REGISTRATION
function handleClickPopupUserRegistration(state, dispatch, popupLayer) {
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;

  const popup = {
    type: 'userRegistrationPopup',
  };

  dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
}

// HANDLE CLICK POPUP LOGIN
function handleClickPopupLogin(state, dispatch, popupLayer, { noteInfo } = {}) {
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;

  const popup = {
    type: 'loginPopup',
    body: {
      noteInfo,
    },
  };

  dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
}

// HANDLE CLICK ADDRESS HISTORY
function handleClickAddressHistory(state, dispatch, cookies, stateKeys, popupLayer) {
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;
  let addressHistory = cookies.addresses;

  if (addressHistory === undefined) {
    addressHistory = [];
  }

  // const options = addressHistory.map( record => <AddressHistoryRecord record={record} stateKeys={stateKeys} layer={popupLayerNext} /> );

  const popup = {
    type: 'addressHistoryPopup',
    body: {
      // title: <AddressHistoryTitle />,
      // options: options,
      addressHistory: addressHistory,
      stateKeys: stateKeys,
    },
  };

  dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
}

export {
  reload,
  reloadGallery,
  getUser,
  getItem,
  getItemNew,
  setAddressesInCookie,
  handleClickPopupUserRegistration,
  handleClickPopupLogin,
  handleClickAddressHistory,
};
